import {createReducer, on} from '@ngrx/store';
import {EntityState, EntityAdapter, createEntityAdapter} from '@ngrx/entity';
import * as fromTemplatesActions from '../_actions/template-entity.actions';
import {ITemplate} from '../_interface/full-template';

export const featureKey = 'templateEntities';

export interface State extends EntityState<ITemplate> {
	loaded: boolean;
	filterTemplates: {
		inUse: boolean;
		active: boolean;
	};
}

export const adapter: EntityAdapter<ITemplate> = createEntityAdapter<ITemplate>(
	{selectId: model => model.templateId}
);

export const initialState: State = adapter.getInitialState({
	loaded: false,
	filterTemplates: {
		inUse: false,
		active: false
	}
});

export const reducer = createReducer(
	initialState,
	on(fromTemplatesActions.loadTemplates,
	(state, action) => {
		return adapter.setAll(action.templates, {...state, loaded: true});
	}),
	on(fromTemplatesActions.updateTemplate,
		((state, action) => {
			return adapter.updateOne(action, state);
		})
	),
	on(fromTemplatesActions.upsertTemplate, (state, {template}) => adapter.upsertOne(template, state)),
	on(fromTemplatesActions.upsertTemplateLocally, (state, {template}) => adapter.upsertOne(template, state)),
	on(fromTemplatesActions.deleteTemplate, (state, {template}) => adapter.upsertOne(template, state)),
	on(fromTemplatesActions.filterTemplatesByActiveInactive, (state) => ({
		...state,
		filterTemplates: {
			...state.filterTemplates,
			active: !state.filterTemplates.active
		}
	})),
	on(fromTemplatesActions.filterTemplatesByUsage, (state) => ({
		...state,
		filterTemplates: {
			...state.filterTemplates,
			inUse: !state.filterTemplates.inUse
		}
	}))
);
